<template>
    <div :class="{ [ 'floor-section-' + floor.id ]:true, floorDiv:true, active:activeFloor === floor.id }" :style="{ bottom: floor.id * resizeOffset + 'px' }" ref="floor">
        <img :src="floor.url"/>
        <div class="video-wrapper" v-if="floor.id === 0">
            <div class="video-center">
                <video autoplay loop plays-inline muted>
                    <source :src="floor.videoUrl">
                </video>
            </div>
            <div class="video-elevator">
                <video autoplay loop plays-inline muted>
                    <source :src="floor.videoUrlElevator">
                </video>
            </div>
        </div>

        <div @mouseover="onHover(index + 1)" @mouseleave="onLeave(index + 1)" @click="showOverlay(index)" v-for="(item, index) in floor.info" :class="`info info-` + (index + 1)">
            <div class="ball non-component">
                <svg height="100%" width="100%">
                    <circle cx="50%" cy="50%" r="40%" stroke="#754098" stroke-width="7" fill="#ffffff" />
                    <text x="50%" y="68%" text-anchor="middle" fill="#754098">{{ index + 1 }}</text>
                </svg>
            </div>
            <!-- <infoBall :ballSize="40" :strokeWidth="7" :fontSize="2"/> -->
            <p :class="`infoBubble text` + (index + 1)">{{ item.title }}</p>
        </div>
        <!-- <button @click="nextFloor"></button> -->
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TimelineMax, TweenMax } from '@/vendor';
    // import ball from '@/app/components/Ball';

    export default {
        components: {
            // 'infoBall': ball
        },

        props: {
            floor: {
                type: Object,
                default: () => { }
            },
            activeFloor: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 0
            }
        },

        data()
        {
            return {
                floorNum: 0,
                resizeOffset: 0
            };
        },

        watch: {
            activeFloor()
            {
                this.renderFloor();
            }
        },

        mounted()
        {
            window.addEventListener( 'resize', this.onResize );
            this.onResize();
            this.renderFloor();
            // this.showOverlay();
        },

        methods: {
            onResize()
            {
                let offsetAt1920Width = 158.57;

                this.resizeOffset = offsetAt1920Width / 1920 * this.$el.clientWidth; // dit was 12.2

                if( this.resizeOffset === 0 )
                {
                    this.resizeOffset = offsetAt1920Width / 1920 * window.innerWidth; // dit was 12.2
                }
            },

            renderFloor()
            {
                let alpha = ( ( 0.3 / this.max ) * ( this.floor.id - this.activeFloor ) );
                if( this.activeFloor >= this.floor.id )
                {
                    alpha = 1;
                }
                TweenMax.to( this.$refs.floor, 0.5, { autoAlpha: alpha });
            },

            onHover( i )
            {
                let tl = new TimelineMax({ paused: true });

                tl.to( '.floor-section-' + this.floor.id + ' .text' + i, 0.5, { autoAlpha: 1 }, 0 );

                tl.play();
            },

            onLeave( i )
            {
                let tl = new TimelineMax({ paused: true });

                tl.to( '.floor-section-' + this.floor.id + ' .text' + i, 0.5, { autoAlpha: 0 }, 0 );

                tl.play();
            },

            showOverlay( i )
            {
                this.$emit( 'requestOverlay', { info: this.floor.info[i], index: i });
            }

        }
    };
</script>
